export default "__VITE_ASSET__6152a4a5__"